import { render, staticRenderFns } from "./PublicReportSort.vue?vue&type=template&id=78a12545"
import script from "./PublicReportSort.vue?vue&type=script&lang=ts"
export * from "./PublicReportSort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZMenuItem: require('/app/components/zeal/ZMenu/ZMenuItem/ZMenuItem.vue').default,ZMenu: require('/app/components/zeal/ZMenu/ZMenu.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZBadge: require('/app/components/zeal/ZBadge/ZBadge.vue').default})
